import { render, staticRenderFns } from "./KurdishContractZaitonPlusCity.vue?vue&type=template&id=1186386a&scoped=true&"
import script from "./KurdishContractZaitonPlusCity.vue?vue&type=script&lang=js&"
export * from "./KurdishContractZaitonPlusCity.vue?vue&type=script&lang=js&"
import style0 from "./KurdishContractZaitonPlusCity.vue?vue&type=style&index=0&id=1186386a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186386a",
  null
  
)

export default component.exports